import React, { useEffect } from "react";
import ReactGA from "react-ga";
import Floors from "./Floors";
import Keyboard from "./Keyboard";
import FilterSectionSkeleton from "./skeleton/FilterSectionSkeleton";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import * as actionTypes from "store/actions/actionTypes";
import {
  screenKeys,
  gaSettings,
  gaSearch,
  mapCatIdToKioskType,
} from "config/constants";
import playClickSpecial from "utils/playClickSpecial";

const FilterSection = ({
  loading,
  floorfilter = false,
  search = false,
  floors = null,
  home = false,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = history.location;
  const floorState = useSelector((state) => state.filter.filterByFloor);
  const searchState = useSelector((state) => state.filter.filterByName);
  const catState = useSelector((state) => state.filter.filterByCategory);
  const facilities = useSelector((state) => state.facilities.facilities)
  const deviceFloorLevelState = useSelector(
    (state) => state.settings.deviceFloorLevel
  );
  const allTags = facilities?.map(ele => {
    if(ele.tags){
      return ele.tags.split(',')
    }
  })
  const flatAllTags = allTags?.flat().map(ele => ele?.trim())
  const handleSelectFloor = (floor) => {
    if (floorState.id !== floor.id) {
      playClickSpecial();
      dispatch({
        type: actionTypes.FILTER_BY_FLOOR,
        payload: {
          id: floor.id,
          code: floor.code,
          name: floor.name,
          trans_name: floor.translate_name
        },
      });

      if (home) {
        //add flag to triggrer map change, flag will be remove when go back
        dispatch({
          type: actionTypes.FILTER_BY_FLOOR_FROM_HOME,
          payload: true,
        });

        history.push(screenKeys.kiosk + "/" + screenKeys.shop);
      }
    }
  };

  const submitGaSearch = (q) => {
    let gaLocation = null;
    let gaTitle = null;
    const pathname = location.pathname;
    if (pathname === gaSearch.kiosk.appPathname) {
      gaTitle = q ? gaSearch.kiosk.title : null;
      gaLocation = q ? gaSearch.kiosk.location + q : null;
    } else if (pathname === gaSearch.kioskShop.appPathname) {
      const catId = catState.id;
      const shopType = mapCatIdToKioskType[catState.id];
      if (catId && shopType) {
        gaTitle = q ? gaSearch[shopType].title : gaSettings[shopType].title;
        gaLocation = q
          ? gaSearch[shopType].location + q
          : gaSettings[shopType].location;
      } else {
        gaTitle = q ? gaSearch.kiosk.title : gaSettings.kiosk.title;
        gaLocation = q
          ? gaSearch.kiosk.location + q
          : gaSettings.kiosk.location;
      }
    } else if (pathname === gaSearch.event.appPathname) {
      gaLocation = q ? gaSearch.event.location + q : gaSettings.event.location;
      gaTitle = q ? gaSearch.event.title : gaSettings.event.title;
    } else if (pathname === gaSearch.promotion.appPathname) {
      gaLocation = q
        ? gaSearch.promotion.location + q
        : gaSettings.promotion.location;
      gaTitle = q ? gaSearch.promotion.title : gaSettings.promotion.title;
    } else if (pathname === gaSearch.foodcourt.appPathname) {
      gaLocation = q ? gaSearch.foodcourt.location + q : null;
      gaTitle = q ? gaSearch.foodcourt.title : null;
    } else {
      //do nothing
    }

    if (gaLocation && gaTitle) {
      ReactGA.pageview(gaLocation, null, gaTitle);
    }
  };

  const handleSubmitSearch = (e, text) => {
    e.preventDefault();
    playClickSpecial();
    const searchText = text.trim();
    submitGaSearch(searchText);
    dispatch({ type: actionTypes.FILTER_BY_NAME, payload: searchText });
  };

  useEffect(() => {
    if (home && searchState && flatAllTags) {
      if(flatAllTags?.includes(searchState)){
        history.push(screenKeys.kiosk + "/" + screenKeys.facilities);
      }else{
        history.push(screenKeys.kiosk + "/" + screenKeys.shop);
      }
      
    }
  }, [searchState]);

  if (loading) {
    return <FilterSectionSkeleton floorfilter={floorfilter} search={search} />;
  }

  return (
    <div>
      {floorfilter && floors && (
        <Floors
          floors={floors}
          select={handleSelectFloor}
          activeFloor={floorState.id}
          userInFloor={deviceFloorLevelState}
        />
      )}
      {search && <Keyboard submit={handleSubmitSearch} oldVal={searchState} />}
    </div>
  );
};

export default FilterSection;
